var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-row",
    [
      _c(
        "ib-col",
        {
          staticClass: "scroll flex  after-8",
          staticStyle: { "max-height": "75vh" },
        },
        [
          _vm.apiStatus === "wait"
            ? _c(
                "ib-table-basic",
                {
                  staticClass: "fs7 fg70 shrink",
                  staticStyle: {
                    border: "1px solid rgba(0,0,0,0.15)",
                    "overscroll-behavior": "contain",
                  },
                  attrs: {
                    data: _vm.progressBarData,
                    row: "",
                    colborder: "",
                    spacing: "huge",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function (res) {
                          return [
                            _c(
                              "td",
                              [
                                _c("ib-progress-circular", {
                                  staticClass: "alignment",
                                  attrs: { width: "128px", height: "128px" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1322037553
                  ),
                },
                [
                  _c("ib-table-col", {
                    staticClass: "header",
                    attrs: { width: "100%" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.apiStatus === "results"
            ? _c(
                "ib-table-basic",
                {
                  staticClass: "fs7 fg70 shrink",
                  staticStyle: {
                    border: "1px solid rgba(0,0,0,0.15)",
                    "overscroll-behavior": "contain",
                  },
                  attrs: {
                    data: _vm.searchResults,
                    row: "",
                    colborder: "",
                    spacing: "huge",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function (res) {
                          return [
                            res["type"] === "BOND"
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                )
                              : res["type"] != "BOND" && res["type"] != "FUND"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: res["symbol"] },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(res["symbol"]))]
                                )
                              : _vm._e(),
                            res["type"] === "FUND"
                              ? _c("td", {
                                  class: {
                                    align:
                                      _vm.checkCusip(res["symbol"]) === "-",
                                  },
                                  attrs: {
                                    title: _vm.checkCusip(res["symbol"]),
                                  },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.checkCusip(res["symbol"])
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            res["description"] != null
                              ? _c("td", {
                                  class: { description: _vm.activateLink(res) },
                                  attrs: {
                                    title: _vm.convertAmpersand(
                                      res["description"],
                                      res["type"],
                                      res["conid"]
                                    ),
                                  },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.convertAmpersand(
                                        res["description"],
                                        res["type"],
                                        res["conid"]
                                      )
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            res["description"] === null
                              ? _c(
                                  "td",
                                  {
                                    class: {
                                      description: _vm.activateLink(res),
                                    },
                                    attrs: { title: res["symbol"] },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(res["symbol"]))]
                                )
                              : _vm._e(),
                            res["type"] === "BOND"
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                )
                              : res["type"] === "FUND"
                              ? _c("td", {
                                  class: {
                                    align:
                                      _vm.checkCusip(res["localSymbol"]) ===
                                      "-",
                                  },
                                  attrs: {
                                    title: _vm.checkCusip(res["localSymbol"]),
                                  },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.checkCusip(res["localSymbol"])
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : res["type"] != "FUND" || res["type"] != "BOND"
                              ? _c(
                                  "td",
                                  { attrs: { title: res["localSymbol"] } },
                                  [
                                    res["localSymbol"].split(",").length < 3 &&
                                    !_vm.showLocalSymbol[res["localSymbol"]]
                                      ? _c(
                                          "span",
                                          {
                                            attrs: {
                                              title: res["localSymbol"]
                                                .split(",")
                                                .slice(0, 2)
                                                .join(),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                res["localSymbol"]
                                                  .split(",")
                                                  .slice(0, 2)
                                                  .join()
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    res["localSymbol"].split(",").length > 2 &&
                                    !_vm.showLocalSymbol[res["localSymbol"]]
                                      ? _c(
                                          "span",
                                          {
                                            attrs: {
                                              title: res["localSymbol"]
                                                .split(",")
                                                .slice(0, 2)
                                                .join(),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                res["localSymbol"]
                                                  .split(",")
                                                  .slice(0, 2)
                                                  .join()
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.showLocalSymbol[res["localSymbol"]]
                                      ? _c(
                                          "span",
                                          {
                                            attrs: {
                                              title: res["localSymbol"],
                                            },
                                          },
                                          [_vm._v(_vm._s(res["localSymbol"]))]
                                        )
                                      : _vm._e(),
                                    res["localSymbol"].split(",").length > 2 &&
                                    !_vm.showLocalSymbol[res["localSymbol"]]
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn-no-style",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleLocalSymbolDetails(
                                                  res
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              ", +" +
                                                _vm._s(
                                                  res["localSymbol"]
                                                    .split(",")
                                                    .slice(2).length
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.showLocalSymbol[res["localSymbol"]] &&
                                    res["localSymbol"].split(",").length > 2
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn-no-style",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleLocalSymbolDetails(
                                                  res
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(", Show Fewer")]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            res["currency"] === null &&
                            res["localSymbol"].includes(".")
                              ? _c("td", {
                                  attrs: {
                                    title: res["localSymbol"].split(".")[1],
                                  },
                                  domProps: {
                                    textContent: _vm._s(
                                      res["localSymbol"].split(".")[1]
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : res["currency"] === null &&
                                res["type"] === "CMDTY"
                              ? _c("td", {
                                  attrs: { title: res["symbol"].substring(3) },
                                  domProps: {
                                    textContent: _vm._s(
                                      res["symbol"].substring(3)
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : res["currency"] === null
                              ? _c("td", {
                                  attrs: { title: "N/A" },
                                  domProps: { textContent: _vm._s("N/A") },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : res["currency"]
                              ? _c("td", {
                                  attrs: { title: res["currency"] },
                                  domProps: {
                                    textContent: _vm._s(res["currency"]),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createlink(
                                        res["symbol"],
                                        res["conid"],
                                        res["underConid"],
                                        res["type"],
                                        res["currency"],
                                        res["country"],
                                        res["assocEntityId"],
                                        res["description"]
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            res["type"] === "STK"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Stocks" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Stocks")]
                                )
                              : _vm._e(),
                            res["type"] === "BOND"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Bonds" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Bonds")]
                                )
                              : _vm._e(),
                            res["type"] === "CMDTY"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Metal" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Metal")]
                                )
                              : _vm._e(),
                            res["type"] === "CFD"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "CFD" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("CFD")]
                                )
                              : _vm._e(),
                            res["type"] === "OPT"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Options" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Options  ")]
                                )
                              : _vm._e(),
                            res["type"] === "FUND"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Mutual Funds" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Mutual Funds")]
                                )
                              : _vm._e(),
                            res["type"] === "WAR"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Warrants" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Warrants")]
                                )
                              : _vm._e(),
                            res["type"] === "FUT"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Futures" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Futures")]
                                )
                              : _vm._e(),
                            res["type"] === "ETF"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "ETF" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("ETF")]
                                )
                              : _vm._e(),
                            res["type"] === "IOPT"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Structured Products" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Structured Products")]
                                )
                              : _vm._e(),
                            res["type"] === "FOP"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Options on Futures" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Options on Futures")]
                                )
                              : _vm._e(),
                            res["type"] === "CRYPTO"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Crypto" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Crypto")]
                                )
                              : _vm._e(),
                            res["type"] === "IND"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Indices" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Indices")]
                                )
                              : _vm._e(),
                            res["type"] === "CASH"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Currencies" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Currencies")]
                                )
                              : _vm._e(),
                            res["country"] === null
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "start-64",
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                )
                              : _vm._e(),
                            res["country"]
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: res["country"] },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(res["country"]))]
                                )
                              : _vm._e(),
                            _vm.newProducts === "T" &&
                            _vm.status === "filterResults"
                              ? _c(
                                  "td",
                                  {
                                    attrs: { title: "Yes" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createlink(
                                          res["symbol"],
                                          res["conid"],
                                          res["underConid"],
                                          res["type"],
                                          res["currency"],
                                          res["country"],
                                          res["assocEntityId"],
                                          res["description"]
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Yes")]
                                )
                              : _vm._e(),
                            _c("td", [
                              res["exchangeId"].split(",").length < 3 &&
                              !_vm.showExchange[res["conid"]]
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: res["exchangeId"]
                                          .split(",")
                                          .slice(0, 2)
                                          .join(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          res["exchangeId"]
                                            .split(",")
                                            .slice(0, 2)
                                            .join()
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              res["exchangeId"].split(",").length > 2 &&
                              !_vm.showExchange[res["conid"]] &&
                              res["conid"] != null
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: res["exchangeId"]
                                          .split(",")
                                          .slice(0, 2)
                                          .join(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          res["exchangeId"]
                                            .split(",")
                                            .slice(0, 2)
                                            .join()
                                        ) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              res["exchangeId"].split(",").length > 2 &&
                              !_vm.showExchange[res["underConid"]] &&
                              res["conid"] === null
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: res["exchangeId"]
                                          .split(",")
                                          .slice(0, 2)
                                          .join(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          res["exchangeId"]
                                            .split(",")
                                            .slice(0, 2)
                                            .join()
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showExchange[res["conid"]]
                                ? _c(
                                    "span",
                                    { attrs: { title: res["exchangeId"] } },
                                    [_vm._v(_vm._s(res["exchangeId"]))]
                                  )
                                : _vm.showExchange[res["underConid"]]
                                ? _c(
                                    "span",
                                    { attrs: { title: res["exchangeId"] } },
                                    [_vm._v(_vm._s(res["exchangeId"]))]
                                  )
                                : _vm._e(),
                              res["exchangeId"].split(",").length > 2 &&
                              !_vm.showExchange[res["conid"]] &&
                              res["conid"] != null
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-no-style",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDetails(res)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        ", +" +
                                          _vm._s(
                                            res["exchangeId"]
                                              .split(",")
                                              .slice(2).length
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              res["exchangeId"].split(",").length > 2 &&
                              !_vm.showExchange[res["underConid"]] &&
                              res["conid"] === null
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-no-style",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDetails(res)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        ", +" +
                                          _vm._s(
                                            res["exchangeId"]
                                              .split(",")
                                              .slice(2).length
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              res["conid"] != null &&
                              _vm.showExchange[res["conid"]] &&
                              res["exchangeId"].split(",").length > 2
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-no-style",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDetails(res)
                                        },
                                      },
                                    },
                                    [_vm._v(", Show Fewer")]
                                  )
                                : _vm._e(),
                              res["exchangeId"].split(",").length > 2 &&
                              _vm.showExchange[res["underConid"]] &&
                              res["conid"] === null
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-no-style",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDetails(res)
                                        },
                                      },
                                    },
                                    [_vm._v(", Show Fewer")]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2827193130
                  ),
                },
                [
                  _c(
                    "ib-table-col",
                    {
                      staticClass: "header",
                      attrs: { width: "9ch", sticky: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("symbol", "")
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { title: _vm.$t("symbol") } }, [
                            _vm._v(_vm._s(_vm.$t("symbol"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "symbol" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("symbol", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "symbol" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("symbol", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "18ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("description", "")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { title: _vm.$t("description") } },
                            [_vm._v(_vm._s(_vm.$t("description")))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "description" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("description", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "description" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("description", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "10ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("local_symbol", "")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { title: _vm.$t("ibkr_symbol") } },
                            [_vm._v(_vm._s(_vm.$t("ibkr_symbol")))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "ibkr_symbol" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("local_symbol", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "ibkr_symbol" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("local_symbol", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "9ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("currency", "")
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { title: _vm.$t("currency") } }, [
                            _vm._v(_vm._s(_vm.$t("currency"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "currency" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("currency", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "currency" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("currency", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "8ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("type", "")
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { title: _vm.$t("product") } }, [
                            _vm._v(_vm._s(_vm.$t("product"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "product" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("type", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "product" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("type", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "8ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("country", "")
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { title: _vm.$t("region") } }, [
                            _vm._v(_vm._s(_vm.$t("region"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "region" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("country", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "region" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("country", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm.newProducts === "T" && _vm.status === "filterResults"
                    ? _c(
                        "ib-table-col",
                        { staticClass: "header", attrs: { width: "10ch" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "border-bottom",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("new", "")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { title: _vm.$t("new_product") } },
                                [_vm._v(_vm._s(_vm.$t("new_product")))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "up",
                                  class: {
                                    "active-sort":
                                      _vm.previousSort.type === "new_product" &&
                                      _vm.previousSort.dir === "asc",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.sortResults("new", "asc")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    { attrs: { viewBox: "0 0 50 50" } },
                                    [
                                      _c("path", {
                                        attrs: { d: "M25 13L4 35h42z" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "down",
                                  class: {
                                    "active-sort":
                                      _vm.previousSort.type === "new_product" &&
                                      _vm.previousSort.dir === "desc",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.sortResults("new", "desc")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    { attrs: { viewBox: "0 0 50 50" } },
                                    [
                                      _c("path", {
                                        attrs: { d: "M4 17l21 22 21-22z" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "ib-table-col",
                    { staticClass: "header", attrs: { width: "16ch" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "border-bottom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("exchange_id", "")
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { title: _vm.$t("exchange") } }, [
                            _vm._v(_vm._s(_vm.$t("exchange"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "up",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "exchange" &&
                                  _vm.previousSort.dir === "asc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("exchange_id", "asc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "down",
                              class: {
                                "active-sort":
                                  _vm.previousSort.type === "exchange" &&
                                  _vm.previousSort.dir === "desc",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.sortResults("exchange_id", "desc")
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: { d: "M4 17l21 22 21-22z" },
                                }),
                              ]),
                            ]
                          ),
                          _vm.isPrimaryExchange
                            ? _c("span", [_vm._v("*Primary Exchange")])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.products.length > 0
            ? _c("div", { staticClass: "pagination" }, [
                _c(
                  "div",
                  [
                    _c("ib-dropdown", {
                      staticClass: "dropdown-style",
                      attrs: {
                        data: _vm.dropdownData,
                        placeholder: _vm.$t("show_rows"),
                        align: "center",
                      },
                      model: {
                        value: _vm.numShow,
                        callback: function ($$v) {
                          _vm.numShow = $$v
                        },
                        expression: "numShow",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination-style" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("page")))]),
                    _c("ib-field", {
                      staticClass: "outsetx-8",
                      attrs: {
                        disabled: _vm.totalPage <= 1,
                        width: "7ch",
                        align: "center",
                        placeholder: "1",
                      },
                      on: { change: _vm.changePage },
                      model: {
                        value: _vm.pageNumber,
                        callback: function ($$v) {
                          _vm.pageNumber = $$v
                        },
                        expression: "pageNumber",
                      },
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("of  "))),
                      _c("strong", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v(_vm._s(_vm.totalPage)),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "page-btn" },
                      [
                        _c(
                          "ib-button",
                          {
                            attrs: { disabled: _vm.pageNumber <= 1 },
                            on: {
                              click: function ($event) {
                                return _vm.changePage(--_vm.pageNumber)
                              },
                            },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M14.78 2.28l-9 9-.69.72.7.72 9 9 1.43-1.44L7.94 12l8.28-8.28z",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _c(
                          "ib-button",
                          {
                            attrs: {
                              disabled: _vm.pageNumber >= _vm.totalPage,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changePage(++_vm.pageNumber)
                              },
                            },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M8.7 2.3L7.3 3.7l8.29 8.3-8.3 8.3 1.42 1.4 9.7-9.7z",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("SearchProducts", { ref: "searchProducts" }),
      _c("InterimPage", { ref: "interimPage" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }